import "core-js/stable";
import "regenerator-runtime/runtime";
import { modal } from "./modal";
import Glide from '@glidejs/glide'

console.log("Vaya Workforce.");
modal();

const menu = document.querySelector(".menu");
const menuBtn = document.querySelector(".menu-btn");
const subMenu = document.querySelector(".sub-menu");
const mainNav = document.getElementById("main-navigation");
const overlay = document.querySelector(".overlay");

function toggleMenu() {
  menu.classList.toggle("open");
  this.classList.toggle("open");

  if (!menu.classList.contains("open")) {
    overlay.classList.remove("open");
  }
}
function closeMenu() {
  menu.classList.remove("open");
  menuBtn.classList.remove("open");
  subMenu.classList.remove("open");
  overlay.classList.remove("open");
}

document.addEventListener("keyup", function(e) {
  if (e.key === "Escape") closeMenu();
});
document.addEventListener("scroll", function() {
  mainNav.classList.add("sticky");
  if (window.scrollY === 0) {
    mainNav.classList.remove("sticky");
  }
});
document.addEventListener("click", function() {
  if (menu.classList.contains("open")) {
    overlay.classList.add("open");
  }
});

menuBtn.addEventListener("click", toggleMenu);
overlay.addEventListener("click", closeMenu);

const homePageSlider = document.querySelector('.homepage-slider');

if (homePageSlider) {
  new Glide(homePageSlider, {
    type: 'carousel',
    startAt: 0,
    perView: 1,

  }).mount();
}
